import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d06888d4")

_pushScopeId("data-v-d06888d4")
const _hoisted_1 = { class: "admin-main-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content-header" }, [
  /*#__PURE__*/_createVNode("h2", null, " 어신 어드민 ")
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 col-6" }
const _hoisted_5 = { class: "small-box bg-info" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createVNode("h3", null, "어신 관리"),
  /*#__PURE__*/_createVNode("p", null, "새로운 주문")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "ion ion-bag" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 바로가기 ")
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_10 = { class: "col-lg-6 col-6" }
const _hoisted_11 = { class: "small-box bg-success" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createVNode("h3", null, "파트너스 관리"),
  /*#__PURE__*/_createVNode("p", null, "주문추이")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "ion ion-stats-bars" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 바로가기 ")
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_16 = { class: "col-lg-6 col-6" }
const _hoisted_17 = { class: "small-box bg-warning" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createVNode("h3", null, "어신 커머스 관리"),
  /*#__PURE__*/_createVNode("p", null, "어신 커머스 관리")
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "ion ion-person-add" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 바로가기 ")
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_22 = { class: "col-lg-6 col-6" }
const _hoisted_23 = { class: "small-box bg-danger" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createVNode("h3", null, "공통 관리"),
  /*#__PURE__*/_createVNode("p", null, "Unique Visitors")
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "ion ion-pie-graph" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 바로가기 ")
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode(_component_router_link, {
            to: "/usin",
            class: "small-box-footer"
          }, {
            default: _withId(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createVNode(_component_router_link, {
            to: "/partners",
            class: "small-box-footer"
          }, {
            default: _withId(() => [
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _hoisted_18,
          _hoisted_19,
          _createVNode(_component_router_link, {
            to: "/commerce",
            class: "small-box-footer"
          }, {
            default: _withId(() => [
              _hoisted_20,
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _hoisted_24,
          _hoisted_25,
          _createVNode(_component_router_link, {
            to: "/commerce/contract",
            class: "small-box-footer"
          }, {
            default: _withId(() => [
              _hoisted_26,
              _hoisted_27
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
})